export default __webpack_public_path__ + "static/media/money-bag(cp).c71a1438.png";